import { GenericAbortSignal } from 'axios';

import http from 'services/http';

// Per-(client, source system) portal automation config: the retrieval-mode
// ladder. Portal credentials live only in the extension's credential store — the server
// never persists them.

export type RetrievalMode = 'manual' | 'extension';

export interface PortalAutomationSettingOptions {
  id: string;
  clientId: string;
  sourceSystem: string;
  retrievalMode: RetrievalMode;
  createdAt: string;
  updatedAt: string;
}

export interface PortalAutomationSettingsIndex {
  data: PortalAutomationSettingOptions[];
}

export const portalAutomationSettingQueryKeys = {
  base: ['portalAutomationSettings'] as const,
  list: (clientId: string) => ['portalAutomationSettings', 'list', clientId] as const,
};

export async function indexPortalAutomationSettings(clientId: string, signal?: GenericAbortSignal) {
  return http
    .get<PortalAutomationSettingsIndex>(`admin/portal_automation_settings`, { params: { client_id: clientId }, signal })
    .then((res) => res.data);
}

export type UpsertPortalAutomationSettingInput = {
  // Top-level field keys are camelCase; OliveBranch snake_cases them on the API.
  clientId: string;
  sourceSystem: string;
  retrievalMode?: RetrievalMode;
};

export async function upsertPortalAutomationSetting(input: UpsertPortalAutomationSettingInput) {
  return http.post<PortalAutomationSettingOptions>(`admin/portal_automation_settings`, input).then((res) => res.data);
}
